import MBBeVoContentSlider from './subcomponent/MBBeVoContentSlider/MBBeVoContentSlider';
import MBBeVoDesc from './subcomponent/MBBeVoDesc/MBBeVoDesc';
import './MainPage.css';
import HomeCarousel from './subcomponent/SwiperSlider/SwiperSlider';
import {useEffect} from 'react';
import {Helmet} from 'react-helmet-async';
import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router-dom';

/**
 * Main page (landing page or home page) component.
 *
 * @returns
 */

export function MainPage() {
    const {t, i18n} = useTranslation();
    const location = useLocation();
    useEffect(() => {
        // Change language based on the current pathname
        const path = location.pathname; // Get the current pathname
        if (path.startsWith('/de') || path === '/de') {
            i18n.changeLanguage('de');
        } else if (path.startsWith('/en') || path === '/en') {
            i18n.changeLanguage('en');
        } else if (path.startsWith('/pt') || path === '/pt') {
            i18n.changeLanguage('pt');
        }

        // Scroll to top on component mount
        window.scrollTo(0, 0);
    }, [location.pathname, i18n]); // Add location.pathname and i18n as dependencies
    return (
        <>
            <Helmet>
                {/* Title & Description */}
                <title>{t("MainPageSEOTitle", "Mercedes-Benz Trucks Operating Fluids | Find Recommended Oils")}</title>
                <meta
                    name="description"
                    content={t(
                        "MainPageSEODescription",
                        "Easily find the recommended engine oil and other approved lubricants for your Mercedes-Benz truck. Enter your VIN for accurate results."
                    )}
                />

                {/* Canonical */}
                <link rel="canonical" href="https://bevo.mercedes-benz-trucks.com/"/>

                {/* Hreflang (hardcoded for homepage) */}
                <link rel="alternate" href="https://bevo.mercedes-benz-trucks.com/en/" hrefLang="en"/>
                <link rel="alternate" href="https://bevo.mercedes-benz-trucks.com/de/" hrefLang="de"/>
                <link rel="alternate" href="https://bevo.mercedes-benz-trucks.com/pt/" hrefLang="pt"/>
                <link rel="alternate" href="https://bevo.mercedes-benz-trucks.com/" hrefLang="x-default"/>

                {/* Open Graph */}
                <meta property="og:title" content={t("MainPageSEOTitle")}/>
                <meta property="og:description" content={t("MainPageSEODescription")}/>
                <meta property="og:type" content="website"/>
                <meta property="og:url" content="https://bevo.mercedes-benz-trucks.com/"/>
                <meta property="og:image" content="https://bevo.mercedes-benz-trucks.com/MB-star_n_web.svg"/>
                <meta property="og:locale" content={i18n.language}/>

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:title" content={t("MainPageSEOTitle")}/>
                <meta name="twitter:description" content={t("MainPageSEODescription")}/>
                <meta name="twitter:image" content="https://bevo.mercedes-benz-trucks.com/MB-star_n_web.svg"/>

                {/* Viewport & Robots */}
                <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
                <meta name="robots" content="index, follow"/>

                {/* Structured Data */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "Mercedes-Benz Trucks Operating Fluids",
                        "url": "https://bevo.mercedes-benz-trucks.com/",
                        "logo": "https://bevo.mercedes-benz-trucks.com/MB-star_n_web.svg",
                        "sameAs": [
                            "https://www.facebook.com/mercedesbenztrucksglobal",
                            "https://x.com/DaimlerTruck"
                        ]
                    })}
                </script>
            </Helmet>
            <HomeCarousel/>
            {/* <div className="mobile-text no-desktop">
             <span className="title">Mercedes Benz Trucks</span><br/>
             <span className="subtitle">Operating Fluids</span>
             </div> */}
            {/* Slider for desktop devices > 992px */}
            {/* <CarSkeleton></CarSkeleton> */}
            {/* Slider for tablet devices > 768px < 992px */}
            {/* <CarSkeletonTablet></CarSkeletonTablet> */}
            {/* Slider for smartphone devices < 768px */}
            {/* <CarSkeletonSmartphone></CarSkeletonSmartphone> */}

            <MBBeVoContentSlider></MBBeVoContentSlider>

            {/* MBBeVoDesc */}
            <MBBeVoDesc></MBBeVoDesc>
        </>
    );
}
